import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PricingPage from '@/pages/pricing';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={PricingPage} />
    </Switch>
  );
}
